export enum WebsocketConnectionState {
  UNINSTANTIATED = "uninstantiated",
  CONNECTING = "connecting",
  OPEN = "open",
  CLOSING = "closing",
  CLOSED = "closed"
}
